var _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 29.5C11.7313 29.5 11.9516 29.4013 12.1246 29.303C12.3117 29.1966 12.5134 29.0491 12.7232 28.8745C13.1439 28.5244 13.6398 28.029 14.1771 27.4306C15.2539 26.2314 16.5315 24.5798 17.7562 22.7494C18.9809 20.919 20.1608 18.8975 21.0366 16.9577C21.9068 15.0299 22.5 13.1325 22.5 11.566C22.5 5.45739 17.5781 0.5 11.5 0.5C5.42192 0.5 0.5 5.45739 0.5 11.566C0.5 13.1325 1.09318 15.0299 1.96343 16.9577C2.83915 18.8975 4.01912 20.919 5.24381 22.7494C6.46854 24.5798 7.74613 26.2314 8.82289 27.4306C9.36015 28.029 9.85606 28.5244 10.2768 28.8745C10.4866 29.0491 10.6883 29.1966 10.8754 29.303C11.0484 29.4013 11.2687 29.5 11.5 29.5Z",
    fill: "#424242",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4992,
    cy: 11.5663,
    rx: 3.675,
    ry: 3.69811,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b84649d4b537c4b855bd8730af24e48e.svg";
export { ForwardRef as ReactComponent };